import React from 'react';
import { Progress, Typography } from 'antd';
import { type BrevoSyncEjecucion, porcentajeFase, computeFaseActual } from '../../api/brevoSyncApi';
import { fmtNumero, FctGlifoAtencion } from '../../fct/react';
import { fct } from '../../fct/tokens/tokens';

const { Text } = Typography;

interface PhaseProgressProps {
  ejecucion: BrevoSyncEjecucion;
}

/** Errores de una fase: con alguno, en la familia aviso (ámbar) con glifo; sin ninguno, texto normal (aceptación GCVSC-I001, 2026-10-04). */
const Errores: React.FC<{ n: number }> = ({ n }) =>
  n > 0
    ? <span style={{ color: fct.estado.aviso.texto, fontWeight: 500 }}><FctGlifoAtencion nivel="atencion" /> {fmtNumero(n)} errores</span>
    : <span>{fmtNumero(n)} errores</span>;

/** Barras de fase (R-15): `Progress` sin color de estado (hereda el tema); cifras en Mono y formato español. */
const PhaseProgress: React.FC<PhaseProgressProps> = ({ ejecucion }) => {
  const fase = computeFaseActual(ejecucion);
  const pctA = porcentajeFase(ejecucion.faseATotal, ejecucion.faseAExitos, ejecucion.faseAErrores);
  const pctB = porcentajeFase(ejecucion.faseBTotal, ejecucion.faseBExitos, ejecucion.faseBErrores);

  const aDone = ejecucion.faseAExitos + ejecucion.faseAErrores;
  const bDone = ejecucion.faseBExitos + ejecucion.faseBErrores;

  return (
    <div style={{ marginBottom: 16 }}>
      {/* Fase A */}
      <div style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          <Text strong style={{ fontSize: 13 }}>Fase A — Sincronizar contactos elegibles</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {fase === 'loading' ? 'Esperando datos…' :
              pctA != null && ejecucion.faseATotal
                ? <span className="fct-mono">{fmtNumero(aDone)} / {fmtNumero(ejecucion.faseATotal)} · <Errores n={ejecucion.faseAErrores} /></span>
                : 'Pendiente'}
          </Text>
        </div>
        <Progress
          percent={pctA ?? 0}
          status={fase === 'A' ? 'active' : (pctA != null && pctA >= 100 ? 'success' : 'normal')}
          size="small"
          showInfo={false}
        />
      </div>

      {/* Fase B */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          <Text strong style={{ fontSize: 13 }}>Fase B — Marcar contactos caídos</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {fase === 'B' && ejecucion.faseBTotal
              ? <span className="fct-mono">{fmtNumero(bDone)} / {fmtNumero(ejecucion.faseBTotal)} · <Errores n={ejecucion.faseBErrores} /></span>
              : 'Empezará tras la fase anterior'}
          </Text>
        </div>
        <Progress
          percent={pctB ?? 0}
          status={fase === 'B' ? 'active' : (pctB != null && pctB >= 100 ? 'success' : 'normal')}
          size="small"
          showInfo={false}
        />
      </div>
    </div>
  );
};

export default PhaseProgress;
